import { FormError } from '@components/modal/form-error/FormError';
import React from 'react';
import styled from '@emotion/styled';
import { ContactForm } from './ContactFormErrorContainer';
import { useI18NextContext } from '@components/hooks';
import { ThemeProps } from '@theme/base';

const ListItem: any = styled.li(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any)
}));

export interface ContactFormErrorProps {
  type: ContactForm;
  errors: Array<string>;
  onClick: () => void;
}

export const ContactFormError = ({ type, errors, onClick }: ContactFormErrorProps) => {
  const t: any = useI18NextContext();
  const body: string = t('contact-form-modal__body--label', { type });
  const renderErrors = () => (
    <ul>
      {errors.map((error: string) => {
        return <ListItem key={error}>{error}</ListItem>;
      })}
    </ul>
  );
  return (
    <FormError
      onClick={onClick}
      renderErrors={renderErrors}
      title={'contact-form-modal__title--label'}
      body={body}
      buttonLabel={'contact-form-modal__button--label'}
    />
  );
};
